import React from 'react'
import Header from '../components/Header';
import Chats from '../components/Chats'

export const ChatsPage = () => {
    return (
        <>
            <Header backButton="/"/>
            <Chats/>
        </>
    )
}
